import React from "react";
import { useLocation } from "react-router-dom";
import { Bell, Video, Zap } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { PLAY_STORE_URL, PLAY_BADGE_FR, PlayStoreIcon } from "./AppBanner";

const isAndroidMobile = () => /Android/i.test(navigator.userAgent);

export const AppPopup = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (!user?.user_id || !user.onboarded || !isAndroidMobile()) return;
    if (location.pathname.startsWith("/auth/") || sessionStorage.getItem("kora_mobile_auth")) return;
    const key = `kora_app_popup_${user.user_id}`;
    if (localStorage.getItem(key)) return;
    const t = setTimeout(() => {
      localStorage.setItem(key, "1");
      setShow(true);
    }, 2500);
    return () => clearTimeout(t);
  }, [user, location.pathname]);

  if (!show) return null;

  return (
    <div data-testid="app-popup-overlay" className="fixed inset-0 z-[90] bg-black/60 flex items-end sm:items-center justify-center p-4" onClick={() => setShow(false)}>
      <div
        data-testid="app-popup"
        className="bg-white rounded-3xl p-6 w-full max-w-sm text-center shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-14 h-14 rounded-2xl bg-kora-sand border border-kora-line flex items-center justify-center mx-auto">
          <PlayStoreIcon size={30} />
        </div>
        <h2 className="font-display font-black text-xl text-kora-ink mt-3">Passez sur l'application !</h2>
        <div className="mt-4 space-y-2.5 text-left">
          <p className="flex items-center gap-2.5 text-sm text-kora-ink/80"><Bell size={16} className="text-kora-terracotta shrink-0" /> Notifications instantanées</p>
          <p className="flex items-center gap-2.5 text-sm text-kora-ink/80"><Video size={16} className="text-kora-terracotta shrink-0" /> Appels vidéo avec vos matchs</p>
          <p className="flex items-center gap-2.5 text-sm text-kora-ink/80"><Zap size={16} className="text-kora-terracotta shrink-0" /> Plus rapide, toujours à portée de main</p>
        </div>
        <a data-testid="app-popup-playstore" href={PLAY_STORE_URL} target="_blank" rel="noreferrer" className="block mt-5">
          <img src={PLAY_BADGE_FR} alt="Disponible sur Google Play" className="h-16 mx-auto" />
        </a>
        <p className="text-[11px] text-kora-muted mt-2 leading-relaxed">
          Connectez-vous avec la <strong>même adresse email Google</strong> que sur le site web : vous retrouverez votre compte, vos matchs et vos conversations, sans vous réinscrire.
        </p>
        <button data-testid="app-popup-later" onClick={() => setShow(false)} className="mt-4 text-sm font-semibold text-kora-muted hover:text-kora-ink">
          Plus tard
        </button>
      </div>
    </div>
  );
};

export default AppPopup;
